export const BANKING_ENTITY_DRIVER_IDS = {
  apy: 'apy',
  bonus: 'bonus',
  monthlyFee: 'monthlyFee',
} as const;

export type BankingEntityDriverId =
  (typeof BANKING_ENTITY_DRIVER_IDS)[keyof typeof BANKING_ENTITY_DRIVER_IDS];
